(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cta-upload-script"] && !Shopify.designMode) return;
  try {
    (() => {
    const MAX_FILE_BYTES = 50 * 1024 * 1024; // 50 MB — IndexedDB can handle it

    window.SketchyRealtorUpload = {
      clear: async function () {
        if (window.PhotoStore) await window.PhotoStore.remove();
        // Clean up any legacy localStorage/sessionStorage entries.
        try {
          localStorage.removeItem('sketchy_realtor_cta_image_v1');
          localStorage.removeItem('sketchy_realtor_cta_image_meta_v1');
          sessionStorage.removeItem('sketchy_realtor_cta_image_v1');
          sessionStorage.removeItem('sketchy_realtor_cta_image_meta_v1');
        } catch (e) {}
      },
    };

    function readMessages() {
      const defaults = {
        image_too_large: 'Please choose an image under 10 MB.',
        storage_failed: 'Could not save your image. Try a smaller file.',
      };
      const el = document.getElementById('cta-upload-messages');
      if (!el || !el.textContent) return defaults;
      try {
        const parsed = JSON.parse(el.textContent.trim());
        return {
          image_too_large: parsed.image_too_large || defaults.image_too_large,
          storage_failed: parsed.storage_failed || defaults.storage_failed,
        };
      } catch (e) {
        return defaults;
      }
    }

    function safeNavigate(href) {
      try {
        const next = new URL(href, window.location.href);
        if (next.origin !== window.location.origin) return;
        // New upload must always restart the create flow from step 1.
        // Keep a URL signal in addition to sessionStorage for reliability.
        next.searchParams.set('step', '1');
        next.searchParams.set('fresh_upload', '1');
        window.location.assign(next.href);
      } catch (e) {
        window.location.assign(window.location.origin);
      }
    }

    let fileInput;

    function getFileInput() {
      if (fileInput && fileInput.parentNode) return fileInput;
      fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = 'image/*';
      fileInput.className = 'cta-upload-input-hidden';
      fileInput.setAttribute('tabindex', '-1');
      fileInput.setAttribute('aria-hidden', 'true');
      document.body.appendChild(fileInput);
      return fileInput;
    }

    document.addEventListener(
      'click',
      (e) => {
        const trigger = e.target.closest('[data-cta-upload]');
        if (!trigger) return;
        e.preventDefault();

        const redirect =
          trigger.getAttribute('data-upload-redirect') || trigger.getAttribute('href') || '/';
        const messages = readMessages();

        const input = getFileInput();
        input.value = '';

        const onChange = async () => {
          input.removeEventListener('change', onChange);
          const file = input.files && input.files[0];
          if (!file || !file.type || file.type.indexOf('image/') !== 0) return;
          if (file.size > MAX_FILE_BYTES) {
            window.alert(messages.image_too_large);
            return;
          }

          // Store the raw File blob in IndexedDB — no base64, no size cap.
          try {
            if (!window.PhotoStore) throw new Error('PhotoStore not loaded');
            await window.PhotoStore.put(file);
          } catch (err) {
            window.alert(messages.storage_failed);
            return;
          }
          // Signal the create flow that this is a brand-new session so
          // it wipes any previous cart / address / custom text / artwork
          // state before hydrating. The flag is consumed (and cleared)
          // by `createFlow().init()` on the next page load.
          try {
            sessionStorage.setItem('sketchy_realtor_fresh_upload', '1');
          } catch (e) {}
          safeNavigate(redirect);
        };

        input.addEventListener('change', onChange);
        input.click();
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-player-script"] && !Shopify.designMode) return;
  try {
    (() => {
    function youtubeId(url) {
      if (!url) return '';
      const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([^&?]+)/);
      return m ? m[1] : '';
    }

    function initPlayer(root) {
      if (root.getAttribute('data-video-inited') === 'true') return;
      root.setAttribute('data-video-inited', 'true');

      const type = root.getAttribute('data-video-type') || 'shopify';
      const poster = root.querySelector('[data-video-poster]');
      const stage = root.querySelector('[data-video-stage]');
      const playBtn = root.querySelector('[data-video-play]');
      const pauseBtn = root.querySelector('[data-video-pause]');
      const videoUrl = root.getAttribute('data-video-url') || '';

      const video = root.querySelector('video');

      function setPlaying(isPlaying) {
        if (isPlaying) {
          root.classList.add('is-playing');
        } else {
          root.classList.remove('is-playing');
        }
      }

      function showStarted() {
        root.classList.add('is-started');
        if (poster) {
          poster.hidden = true;
        }
        if (stage) {
          stage.classList.remove('opacity-0', 'pointer-events-none');
          stage.classList.add('opacity-100');
        }
      }

      function resetYoutube() {
        const iframe = stage && stage.querySelector('iframe[data-video-youtube]');
        if (iframe) {
          iframe.remove();
        }
        setPlaying(false);
        root.classList.remove('is-started');
        if (poster) {
          poster.hidden = false;
        }
        if (stage) {
          stage.classList.add('opacity-0', 'pointer-events-none');
          stage.classList.remove('opacity-100', 'pointer-events-auto');
        }
      }

      function playVideo() {
        if (type === 'youtube') {
          const id = youtubeId(videoUrl);
          if (!id || !stage) return;
          showStarted();
          let iframe = stage.querySelector('iframe[data-video-youtube]');
          if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.setAttribute('data-video-youtube', '');
            iframe.className = 'absolute inset-0 h-full w-full';
            iframe.setAttribute(
              'src',
              'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0'
            );
            iframe.setAttribute('title', 'Video');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute(
              'allow',
              'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            );
            stage.appendChild(iframe);
          }
          stage.classList.remove('pointer-events-none');
          stage.classList.add('pointer-events-auto');
          setPlaying(true);
          return;
        }

        if (video) {
          showStarted();
          video
            .play()
            .then(() => {
              setPlaying(true);
            })
            .catch(() => {});
        }
      }

      if (playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          playVideo();
        });
      }

      if (pauseBtn) {
        pauseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (type === 'youtube') {
            resetYoutube();
            return;
          }

          if (video) {
            video.pause();
            setPlaying(false);
          }
        });
      }

      root.addEventListener(
        'click',
        (e) => {
          if (e.target.closest('[data-video-pause]')) return;
          if (e.target.closest('[data-video-play]')) return;

          if (!root.classList.contains('is-playing')) {
            playVideo();
            return;
          }

          if (type === 'youtube') {
            if (e.target.closest('iframe')) return;
            resetYoutube();
            return;
          }
          if (video) {
            video.pause();
          }
        },
        false
      );

      if (video) {
        video.addEventListener('ended', () => {
          setPlaying(false);
        });

        video.addEventListener('pause', () => {
          if (!video.ended) {
            setPlaying(false);
          }
        });

        video.addEventListener('play', () => {
          setPlaying(true);
        });
      }
    }

    document.querySelectorAll('[data-video-player]').forEach(initPlayer);

    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('[data-video-player]').forEach(initPlayer);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
